const SHOW_BANNER = 'blayzr/banners/SHOW_BANNER'
const HIDE_BANNER = 'blayzr/banners/HIDE_BANNER'

const BANNER_TIMEOUT = 3000

const initialState = []

export default function reducer (state = initialState, action = {}) {
  const { type, payload, meta } = action
  switch (type) {
    case SHOW_BANNER:
      return state.concat(payload)
    case HIDE_BANNER:
      return state.filter(banner => banner.id !== meta.id)
    default:
      return state
  }
}

let counter = 0

export function showBanner (text) {
  const id = counter++
  return dispatch => {
    dispatch({
      type: SHOW_BANNER,
      payload: { id, text }
    })
    setTimeout(() => {
      dispatch({
        type: HIDE_BANNER,
        meta: { id }
      })
    }, BANNER_TIMEOUT)
  }
}

export function hideBanner (id) {
  return {
    type: HIDE_BANNER,
    meta: { id }
  }
}



// WEBPACK FOOTER //
// ./src/redux/banners.js